// ─────────────────────────────────────────────────────────────
//  SITE MANAGEMENT DUMMY DATA
// ─────────────────────────────────────────────────────────────

const SOLUTION_META = {
  STP:        { color: "#8b5cf6", bg: "#ede9fe", label: "STP" },
  AQM:        { color: "#10b981", bg: "#d1fae5", label: "AQM" },
  Irrigation: { color: "#f59e0b", bg: "#fef3c7", label: "Irrigation" },
  Water:      { color: "#3b82f6", bg: "#dbeafe", label: "Water" },
  Facility:   { color: "#667eea", bg: "#e0e7ff", label: "Facility" },
  Fleet:      { color: "#f97316", bg: "#ffedd5", label: "Fleet" },
};

export { SOLUTION_META };

export const siteDummyData = {

  // ── Organizations (one per customer/company) ──────────────────────────────
  organizations: [
    {
      id: "ORG-001", name: "Tata Industries Ltd.", type: "Industrial",
      siteIds: ["SITE-001"],
      registration: "U27100MH1989PLC052270", gst: "27AABCT3518Q1ZC",
      address: "Bombay House, 24 Homi Mody St, Fort, Mumbai 400001, MH",
      contact: "Arjun Tata", email: "arjun.tata@tataindustries.com", phone: "+91-22-6665-8282",
      description: "Integrated industrial manufacturing & utilities monitoring across MIDC zones.",
      plan: "Enterprise", maxSites: 20, maxDevices: 500,
      solutionsEnabled: ["STP", "AQM", "Fleet", "Water", "Facility"],
      dataRetention: "24 months", slaLevel: "99.5%", apiAccess: true,
      status: "Active", createdAt: "2023-01-15",
      adminUser: { name: "Arjun Tata", email: "arjun.tata@tataindustries.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: ["SMS", "Email", "WhatsApp"],
    },
    {
      id: "ORG-002", name: "Infosys Pune Campus", type: "IT/Commercial",
      siteIds: ["SITE-002"],
      registration: "U72200KA1981PLC013115", gst: "29AAACI1681G1ZZ",
      address: "Plot 44, Electronic City, Hosur Road, Bengaluru 560100, KA",
      contact: "Salil Parekh", email: "salil.parekh@infosys.com", phone: "+91-80-2852-0261",
      description: "Smart campus solution for Infosys Pune IT park — air quality, facility, water.",
      plan: "Professional", maxSites: 5, maxDevices: 150,
      solutionsEnabled: ["AQM", "Facility", "Water"],
      dataRetention: "12 months", slaLevel: "99.0%", apiAccess: true,
      status: "Active", createdAt: "2023-06-01",
      adminUser: { name: "Priya Kulkarni", email: "priya.kulkarni@infosys.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: ["Email", "Push"],
    },
    {
      id: "ORG-003", name: "Sula Vineyards Pvt. Ltd.", type: "Agriculture",
      siteIds: ["SITE-003"],
      registration: "U01111MH2001PTC129647", gst: "27AAFCS4028R1Z4",
      address: "Govardhan, P.O. Dindori, Nashik 422202, MH",
      contact: "Rajeev Samant", email: "rajeev.samant@sula.com", phone: "+91-253-2301042",
      description: "Precision agriculture IoT for India's leading winery — irrigation, water, soil.",
      plan: "Basic", maxSites: 3, maxDevices: 50,
      solutionsEnabled: ["Irrigation", "Water"],
      dataRetention: "6 months", slaLevel: "98.0%", apiAccess: false,
      status: "Active", createdAt: "2023-12-20",
      adminUser: { name: "Anil Gaikwad", email: "anil.gaikwad@sula.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: ["SMS"],
    },
    {
      id: "ORG-004", name: "Bajaj Auto Components", type: "Industrial",
      siteIds: ["SITE-004"],
      registration: "U35914MH1945PLC004659", gst: "27AABCB1947Q1Z1",
      address: "Akurdi, Pune 411035, MH",
      contact: "Rajiv Bajaj", email: "rajiv.bajaj@bajaj.com", phone: "+91-20-2747-2851",
      description: "Compliance-grade STP & AQM monitoring for auto manufacturing plants.",
      plan: "Enterprise", maxSites: 15, maxDevices: 400,
      solutionsEnabled: ["STP", "AQM", "Fleet"],
      dataRetention: "36 months", slaLevel: "99.5%", apiAccess: true,
      status: "Active", createdAt: "2022-11-05",
      adminUser: { name: "Vikram Singh", email: "vikram.singh@bajaj.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: ["SMS", "Email", "WhatsApp"],
    },
    {
      id: "ORG-005", name: "Lodha Group Properties", type: "Real Estate",
      siteIds: ["SITE-005"],
      registration: "U45200MH1980PLC022958", gst: "27AAACL2893D1Z3",
      address: "412, Lodha Supremus, Saki Vihar Road, Mumbai 400072, MH",
      contact: "Abhishek Lodha", email: "abhishek.lodha@lodha.com", phone: "+91-22-6111-0000",
      description: "Smart residential complex water management, air quality, and resident portals.",
      plan: "Professional", maxSites: 10, maxDevices: 250,
      solutionsEnabled: ["Water", "AQM", "Facility"],
      dataRetention: "12 months", slaLevel: "99.0%", apiAccess: false,
      status: "Active", createdAt: "2023-09-10",
      adminUser: { name: "Neha Shah", email: "neha.shah@lodha.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: ["SMS", "Push"],
    },
    {
      id: "ORG-006", name: "TCS IT Campus Airoli", type: "IT/Commercial",
      siteIds: ["SITE-006"],
      registration: "U72900MH1968PLC012389", gst: "27AAACR4849E1ZO",
      address: "TCS House, Raveline Street, Fort, Mumbai 400001, MH",
      contact: "K. Krithivasan", email: "k.krithivasan@tcs.com", phone: "+91-22-6778-9000",
      description: "Enterprise campus monitoring — AQM, facility management, fleet & water.",
      plan: "Enterprise", maxSites: 8, maxDevices: 300,
      solutionsEnabled: ["AQM", "Facility", "Fleet", "Water"],
      dataRetention: "18 months", slaLevel: "99.5%", apiAccess: true,
      status: "Active", createdAt: "2022-08-01",
      adminUser: { name: "Deepak Verma", email: "deepak.verma@tcs.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: ["SMS", "Email", "WhatsApp", "Push"],
    },
    {
      id: "ORG-007", name: "Bhogavati Sugar Co-Op", type: "Agriculture",
      siteIds: ["SITE-007"],
      registration: "U15400MH2010PTC210345", gst: "27AABCB3371Q1ZY",
      address: "Gavat Road, Kagal, Kolhapur 416006, MH",
      contact: "Ganesh Patil", email: "ganesh.patil@bhogavati.com", phone: "+91-231-265-8901",
      description: "Sugar mill process water & STP monitoring — currently on trial evaluation.",
      plan: "Basic", maxSites: 2, maxDevices: 30,
      solutionsEnabled: ["STP", "Water", "Irrigation"],
      dataRetention: "3 months", slaLevel: "97.0%", apiAccess: false,
      status: "Trial", createdAt: "2024-11-15",
      adminUser: { name: "Ganesh Patil", email: "ganesh.patil@bhogavati.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: ["SMS"],
    },
    {
      id: "ORG-008", name: "Shri Renuka Textiles", type: "Industrial",
      siteIds: ["SITE-008"],
      registration: "U17111MH2000PTC127851", gst: "27AAECS6782M1Z2",
      address: "SIDCO Industrial Area, Akkalkot Road, Solapur 413006, MH",
      contact: "Ramesh Jadhav", email: "ramesh.jadhav@renuka.com", phone: "+91-217-273-0011",
      description: "Textile dyeing & effluent monitoring (STP + AQM) — subscription lapsed.",
      plan: "Professional", maxSites: 5, maxDevices: 100,
      solutionsEnabled: ["STP", "AQM"],
      dataRetention: "6 months", slaLevel: "98.5%", apiAccess: false,
      status: "Inactive", createdAt: "2023-05-20",
      adminUser: { name: "Ramesh Jadhav", email: "ramesh.jadhav@renuka.com", role: "Org Admin" },
      timezone: "Asia/Kolkata",
      notificationDefaults: [],
    },
  ],

  sites: [
    {
      id: "SITE-001",
      name: "Mumbai Industrial Plant",
      type: "Factory",
      org: "Tata Industries Ltd.",
      orgId: "ORG-001",
      address: "Plot 14, MIDC Andheri East, Mumbai 400093, MH",
      lat: 19.115, lng: 72.868,
      timezone: "IST (UTC+5:30)",
      contact: "Rajesh Mehta",
      phone: "+91-98200-12345",
      email: "rajesh.mehta@tataindustries.com",
      status: "Active",
      plan: "Enterprise",
      healthScore: 72,
      uptime: 94.2,
      createdAt: "2023-04-15",
      solutions: [
        { id: "STP",   name: "STP",   enabled: true,  plan: "Enterprise", deviceCount: 8,  activeAlerts: 2, features: ["Bio-reactor", "Sludge Monitor", "Effluent Track"] },
        { id: "AQM",   name: "AQM",   enabled: true,  plan: "Enterprise", deviceCount: 6,  activeAlerts: 1, features: ["PM2.5/PM10", "CO2/VOC", "Compliance Report"] },
        { id: "Fleet", name: "Fleet", enabled: true,  plan: "Professional", deviceCount: 10, activeAlerts: 1, features: ["Live Tracking", "Fuel Analytics", "Driver Score"] },
        { id: "Water", name: "Water", enabled: true,  plan: "Basic",       deviceCount: 4,  activeAlerts: 0, features: ["Tank Monitor", "Pump Control"] },
      ],
      devices: [
        { id: "GW-MUM-001", name: "Mumbai Gateway 01",   type: "Gateway",    connectivity: "Ethernet", status: "Online",  health: 94, lastSeen: "1 min ago" },
        { id: "STP-MUM-001", name: "STP Bio-Reactor 01", type: "Sensor",     connectivity: "LoRa",     status: "Online",  health: 88, lastSeen: "2 min ago" },
        { id: "STP-MUM-002", name: "STP Effluent Meter", type: "Controller", connectivity: "Modbus",   status: "Online",  health: 76, lastSeen: "3 min ago" },
        { id: "AQM-MUM-001", name: "AQM Node 01 (Roof)", type: "Sensor",     connectivity: "LoRa",     status: "Online",  health: 91, lastSeen: "1 min ago" },
        { id: "AQM-MUM-002", name: "AQM Node 02 (Shop)", type: "Sensor",     connectivity: "WiFi",     status: "Offline", health: 22, lastSeen: "3h ago"   },
        { id: "WTR-MUM-001", name: "Water Tank Level 01", type: "Sensor",    connectivity: "LoRa",     status: "Online",  health: 95, lastSeen: "2 min ago" },
        { id: "WTR-MUM-002", name: "Pump Controller 01",  type: "Controller", connectivity: "Modbus",  status: "Online",  health: 87, lastSeen: "5 min ago" },
        { id: "TRK-MUM-001", name: "Fleet Tracker 01",   type: "Sensor",     connectivity: "Cellular", status: "Online",  health: 92, lastSeen: "30s ago"  },
      ],
      users: [
        { id: "U001", name: "Rajesh Mehta",    role: "Site Admin",       email: "rajesh.mehta@tataindustries.com",   status: "Active", lastLogin: "Today 09:12" },
        { id: "U002", name: "Kavita Sharma",   role: "Facility Manager", email: "kavita.sharma@tataindustries.com",  status: "Active", lastLogin: "Today 10:45" },
        { id: "U003", name: "Sunil Patil",     role: "Technician",       email: "sunil.patil@tataindustries.com",    status: "Active", lastLogin: "Yesterday"   },
        { id: "U004", name: "Anjali Desai",    role: "Technician",       email: "anjali.desai@tataindustries.com",   status: "Active", lastLogin: "2 days ago"  },
        { id: "U005", name: "Mohan Rao",       role: "Viewer",           email: "mohan.rao@tataindustries.com",      status: "Inactive", lastLogin: "7 days ago"  },
      ],
      alerts: [
        { id: "SA-001", severity: "Critical", type: "STP Fault",     message: "STP Bio-Reactor 01 – pH sensor out of range (>9.5). Effluent compliance risk.", time: "08:42 AM", status: "Active",       assignee: "Sunil Patil"   },
        { id: "SA-002", severity: "Critical", type: "Device Offline", message: "AQM Node 02 (Shop Floor) offline for 3h. Air quality unmonitored.", time: "06:10 AM", status: "Active",       assignee: "Kavita Sharma" },
        { id: "SA-003", severity: "Warning",  type: "AQM Threshold",  message: "PM2.5 at 88 µg/m³ – approaching CPCB limit (90). Action recommended.", time: "09:15 AM", status: "Acknowledged", assignee: "Anjali Desai"  },
        { id: "SA-004", severity: "Warning",  type: "Fleet Alert",    message: "Fleet Tracker 01 – vehicle idle >60 min at depot. Fuel waste detected.", time: "10:02 AM", status: "Active",       assignee: "—"             },
      ],
      settings: {
        escalation: "30 min → Site Admin → 2h → Org Admin",
        maintenanceWindow: "Sunday 02:00–04:00 IST",
        slaTarget: "99.0%",
        dataRetention: "12 months",
        notificationChannels: ["SMS", "Email", "WhatsApp"],
      },
    },

    {
      id: "SITE-002",
      name: "Pune Office Tower",
      type: "Commercial",
      org: "Infosys Pune Campus",
      orgId: "ORG-002",
      address: "Hinjewadi Phase 2, Pune 411057, MH",
      lat: 18.591, lng: 73.738,
      timezone: "IST (UTC+5:30)",
      contact: "Priya Kulkarni",
      phone: "+91-97300-45678",
      email: "priya.kulkarni@infosys.com",
      status: "Active",
      plan: "Professional",
      healthScore: 88,
      uptime: 99.1,
      createdAt: "2023-07-20",
      solutions: [
        { id: "AQM",      name: "AQM",      enabled: true, plan: "Professional", deviceCount: 8, activeAlerts: 1, features: ["PM2.5/PM10", "CO2/VOC"] },
        { id: "Facility", name: "Facility", enabled: true, plan: "Professional", deviceCount: 6, activeAlerts: 0, features: ["HVAC Control", "Occupancy", "Energy"] },
        { id: "Water",    name: "Water",    enabled: true, plan: "Basic",        deviceCount: 2, activeAlerts: 0, features: ["Tank Monitor"] },
      ],
      devices: [
        { id: "GW-PUN-001", name: "Pune Campus Gateway",   type: "Gateway",    connectivity: "Ethernet", status: "Online", health: 98, lastSeen: "1 min ago" },
        { id: "AQM-PUN-001", name: "AQM Node – Ground",   type: "Sensor",     connectivity: "WiFi",     status: "Online", health: 94, lastSeen: "2 min ago" },
        { id: "AQM-PUN-002", name: "AQM Node – Floor 5",  type: "Sensor",     connectivity: "WiFi",     status: "Online", health: 90, lastSeen: "3 min ago" },
        { id: "FAC-PUN-001", name: "HVAC Controller 01",  type: "Controller", connectivity: "Modbus",   status: "Online", health: 88, lastSeen: "5 min ago" },
        { id: "WTR-PUN-001", name: "Water Level Sensor",  type: "Sensor",     connectivity: "LoRa",     status: "Online", health: 96, lastSeen: "2 min ago" },
      ],
      users: [
        { id: "U010", name: "Priya Kulkarni",  role: "Site Admin",       email: "priya.kulkarni@infosys.com", status: "Active", lastLogin: "Today 08:30" },
        { id: "U011", name: "Sanjay More",     role: "Facility Manager", email: "sanjay.more@infosys.com",    status: "Active", lastLogin: "Today 09:00" },
        { id: "U012", name: "Rita Joshi",      role: "Technician",       email: "rita.joshi@infosys.com",     status: "Active", lastLogin: "Today 07:45" },
      ],
      alerts: [
        { id: "SA-010", severity: "Warning", type: "AQM Threshold", message: "CO2 at 1,020 ppm in Floor 5 conf room. Ventilation recommended.", time: "10:30 AM", status: "Active", assignee: "Rita Joshi" },
      ],
      settings: {
        escalation: "1h → Site Admin → 4h → Org Admin",
        maintenanceWindow: "Saturday 00:00–02:00 IST",
        slaTarget: "99.5%",
        dataRetention: "6 months",
        notificationChannels: ["Email", "Push"],
      },
    },

    {
      id: "SITE-003",
      name: "Nashik Vineyard & Farm",
      type: "Farm",
      org: "Sula Vineyards Pvt. Ltd.",
      orgId: "ORG-003",
      address: "Gat No. 36, Dindori Road, Nashik 422202, MH",
      lat: 20.018, lng: 73.792,
      timezone: "IST (UTC+5:30)",
      contact: "Anil Gaikwad",
      phone: "+91-94220-78901",
      email: "anil.gaikwad@sula.com",
      status: "Active",
      plan: "Basic",
      healthScore: 94,
      uptime: 99.8,
      createdAt: "2024-01-10",
      solutions: [
        { id: "Irrigation", name: "Irrigation", enabled: true, plan: "Basic", deviceCount: 6, activeAlerts: 0, features: ["Drip Control", "Soil Moisture", "Weather"] },
        { id: "Water",      name: "Water",      enabled: true, plan: "Basic", deviceCount: 3, activeAlerts: 0, features: ["Tank Monitor", "Rain Gauge"] },
      ],
      devices: [
        { id: "GW-NSK-001", name: "Farm Gateway",          type: "Gateway",    connectivity: "Cellular", status: "Online", health: 96, lastSeen: "3 min ago" },
        { id: "IRR-NSK-001", name: "Drip Controller Z1",  type: "Controller", connectivity: "LoRa",     status: "Online", health: 98, lastSeen: "2 min ago" },
        { id: "IRR-NSK-002", name: "Soil Moisture Z1",    type: "Sensor",     connectivity: "LoRa",     status: "Online", health: 95, lastSeen: "1 min ago" },
        { id: "WTR-NSK-001", name: "Farm Tank Level",     type: "Sensor",     connectivity: "LoRa",     status: "Online", health: 97, lastSeen: "2 min ago" },
      ],
      users: [
        { id: "U020", name: "Anil Gaikwad",  role: "Site Admin", email: "anil.gaikwad@sula.com", status: "Active", lastLogin: "Today 06:15" },
        { id: "U021", name: "Seema Naik",    role: "Technician", email: "seema.naik@sula.com",   status: "Active", lastLogin: "Yesterday"   },
      ],
      alerts: [],
      settings: {
        escalation: "2h → Site Admin → Org Admin",
        maintenanceWindow: "Wednesday 22:00–00:00 IST",
        slaTarget: "98.0%",
        dataRetention: "3 months",
        notificationChannels: ["SMS"],
      },
    },

    {
      id: "SITE-004",
      name: "Aurangabad Auto Parts Factory",
      type: "Factory",
      org: "Bajaj Auto Components",
      orgId: "ORG-004",
      address: "A-24, Chikalthana MIDC, Aurangabad 431006, MH",
      lat: 19.900, lng: 75.337,
      timezone: "IST (UTC+5:30)",
      contact: "Vikram Singh",
      phone: "+91-96570-23456",
      email: "vikram.singh@bajaj.com",
      status: "Active",
      plan: "Enterprise",
      healthScore: 65,
      uptime: 91.3,
      createdAt: "2023-01-28",
      solutions: [
        { id: "STP",   name: "STP",   enabled: true, plan: "Enterprise", deviceCount: 9,  activeAlerts: 2, features: ["Multi-stage Treatment", "Compliance Report"] },
        { id: "AQM",   name: "AQM",   enabled: true, plan: "Professional", deviceCount: 7, activeAlerts: 0, features: ["PM2.5/PM10", "VOC"] },
        { id: "Fleet", name: "Fleet", enabled: true, plan: "Basic",       deviceCount: 6,  activeAlerts: 0, features: ["Live Tracking"] },
      ],
      devices: [
        { id: "GW-AUR-001", name: "Aurangabad Gateway",   type: "Gateway",    connectivity: "Ethernet", status: "Online",  health: 89, lastSeen: "2 min ago" },
        { id: "STP-AUR-001", name: "STP Primary Tank",    type: "Sensor",     connectivity: "Modbus",   status: "Online",  health: 55, lastSeen: "10 min ago" },
        { id: "STP-AUR-002", name: "STP Secondary Tank",  type: "Sensor",     connectivity: "Modbus",   status: "Fault",   health: 18, lastSeen: "45 min ago" },
        { id: "AQM-AUR-001", name: "AQM Shop Floor 01",   type: "Sensor",     connectivity: "WiFi",     status: "Online",  health: 82, lastSeen: "1 min ago"  },
      ],
      users: [
        { id: "U030", name: "Vikram Singh",   role: "Site Admin",       email: "vikram.singh@bajaj.com",   status: "Active", lastLogin: "Today 07:30" },
        { id: "U031", name: "Pooja Wagh",     role: "Facility Manager", email: "pooja.wagh@bajaj.com",     status: "Active", lastLogin: "Today 08:00" },
        { id: "U032", name: "Raju Kamble",    role: "Technician",       email: "raju.kamble@bajaj.com",    status: "Active", lastLogin: "Today 06:50" },
        { id: "U033", name: "Deepa Shinde",   role: "Viewer",           email: "deepa.shinde@bajaj.com",   status: "Active", lastLogin: "3 days ago"  },
      ],
      alerts: [
        { id: "SA-030", severity: "Critical", type: "STP Fault",     message: "STP Secondary Tank – sensor failure. Effluent overflow risk. Immediate action needed.", time: "07:18 AM", status: "Active",       assignee: "Raju Kamble" },
        { id: "SA-031", severity: "Critical", type: "Compliance",    message: "STP discharge BOD reading 42 mg/L – above MPCB limit of 30 mg/L.",                      time: "Yesterday",  status: "Acknowledged", assignee: "Vikram Singh" },
      ],
      settings: {
        escalation: "15 min → Site Admin → 1h → Org Admin → MPCB Team",
        maintenanceWindow: "Sunday 01:00–05:00 IST",
        slaTarget: "98.5%",
        dataRetention: "24 months",
        notificationChannels: ["SMS", "Email", "WhatsApp"],
      },
    },

    {
      id: "SITE-005",
      name: "Thane Residential Complex",
      type: "Apartment",
      org: "Lodha Group Properties",
      orgId: "ORG-005",
      address: "Lodha Amara, Kolshet Road, Thane 400607, MH",
      lat: 19.215, lng: 72.981,
      timezone: "IST (UTC+5:30)",
      contact: "Neha Shah",
      phone: "+91-89760-34567",
      email: "neha.shah@lodha.com",
      status: "Active",
      plan: "Professional",
      healthScore: 91,
      uptime: 99.3,
      createdAt: "2023-11-05",
      solutions: [
        { id: "Water", name: "Water", enabled: true, plan: "Professional", deviceCount: 8, activeAlerts: 1, features: ["Tank Monitor", "Pump Control", "Billing"] },
        { id: "AQM",   name: "AQM",   enabled: true, plan: "Basic",        deviceCount: 4, activeAlerts: 0, features: ["PM2.5", "CO2"] },
      ],
      devices: [
        { id: "GW-THN-001", name: "Thane Complex Gateway", type: "Gateway",    connectivity: "Ethernet", status: "Online",  health: 97, lastSeen: "1 min ago" },
        { id: "WTR-THN-001", name: "Overhead Tank A",      type: "Sensor",     connectivity: "LoRa",     status: "Online",  health: 93, lastSeen: "2 min ago" },
        { id: "WTR-THN-002", name: "Overhead Tank B",      type: "Sensor",     connectivity: "LoRa",     status: "Online",  health: 91, lastSeen: "2 min ago" },
        { id: "WTR-THN-003", name: "Pump Controller A",    type: "Controller", connectivity: "Modbus",   status: "Online",  health: 85, lastSeen: "5 min ago" },
        { id: "AQM-THN-001", name: "Lobby AQM Sensor",    type: "Sensor",     connectivity: "WiFi",     status: "Online",  health: 94, lastSeen: "1 min ago" },
      ],
      users: [
        { id: "U040", name: "Neha Shah",      role: "Site Admin",  email: "neha.shah@lodha.com",   status: "Active", lastLogin: "Today 09:00" },
        { id: "U041", name: "Ravi Thakur",    role: "Technician",  email: "ravi.thakur@lodha.com", status: "Active", lastLogin: "Today 07:30" },
        { id: "U042", name: "Mr. Residents",  role: "Viewer",      email: "residents@lodha.com",   status: "Active", lastLogin: "Today 11:00" },
      ],
      alerts: [
        { id: "SA-040", severity: "Warning", type: "Water Level", message: "Overhead Tank B at 22% – below 25% threshold. Pump auto-start triggered.", time: "10:45 AM", status: "Acknowledged", assignee: "Ravi Thakur" },
      ],
      settings: {
        escalation: "1h → Site Admin → Society Manager",
        maintenanceWindow: "Friday 23:00–01:00 IST",
        slaTarget: "99.0%",
        dataRetention: "6 months",
        notificationChannels: ["SMS", "Push"],
      },
    },

    {
      id: "SITE-006",
      name: "Navi Mumbai IT Campus",
      type: "Commercial",
      org: "TCS IT Campus Airoli",
      orgId: "ORG-006",
      address: "TCS Synergy Park, Airoli, Navi Mumbai 400708, MH",
      lat: 19.155, lng: 72.999,
      timezone: "IST (UTC+5:30)",
      contact: "Deepak Verma",
      phone: "+91-91220-56789",
      email: "deepak.verma@tcs.com",
      status: "Active",
      plan: "Enterprise",
      healthScore: 79,
      uptime: 97.8,
      createdAt: "2022-09-01",
      solutions: [
        { id: "AQM",      name: "AQM",      enabled: true, plan: "Enterprise",    deviceCount: 12, activeAlerts: 2, features: ["PM2.5/PM10", "CO2/VOC", "Dashboard"] },
        { id: "Facility", name: "Facility", enabled: true, plan: "Enterprise",    deviceCount: 14, activeAlerts: 1, features: ["HVAC", "Occupancy", "Energy", "Security"] },
        { id: "Fleet",    name: "Fleet",    enabled: true, plan: "Professional",  deviceCount: 6,  activeAlerts: 0, features: ["Live Tracking", "Fuel"] },
        { id: "Water",    name: "Water",    enabled: true, plan: "Basic",         deviceCount: 2,  activeAlerts: 0, features: ["Tank Monitor"] },
      ],
      devices: [
        { id: "GW-NVM-001", name: "Campus Gateway 01",    type: "Gateway",    connectivity: "Ethernet", status: "Online",  health: 96, lastSeen: "1 min ago" },
        { id: "AQM-NVM-001", name: "AQM – Lobby",         type: "Sensor",     connectivity: "WiFi",     status: "Online",  health: 90, lastSeen: "1 min ago" },
        { id: "AQM-NVM-002", name: "AQM – 3rd Floor",     type: "Sensor",     connectivity: "WiFi",     status: "Offline", health: 32, lastSeen: "2h ago"   },
        { id: "FAC-NVM-001", name: "HVAC Ctrl Main",      type: "Controller", connectivity: "Modbus",   status: "Online",  health: 82, lastSeen: "3 min ago" },
        { id: "FAC-NVM-002", name: "Occupancy Sensor B2", type: "Sensor",     connectivity: "BLE",      status: "Online",  health: 78, lastSeen: "5 min ago" },
      ],
      users: [
        { id: "U050", name: "Deepak Verma",    role: "Site Admin",       email: "deepak.verma@tcs.com",    status: "Active", lastLogin: "Today 08:00" },
        { id: "U051", name: "Smita Pandey",    role: "Facility Manager", email: "smita.pandey@tcs.com",    status: "Active", lastLogin: "Today 09:30" },
        { id: "U052", name: "Arjun Rao",       role: "Technician",       email: "arjun.rao@tcs.com",       status: "Active", lastLogin: "Today 07:15" },
        { id: "U053", name: "Kavya Nair",      role: "Technician",       email: "kavya.nair@tcs.com",      status: "Active", lastLogin: "Yesterday"   },
        { id: "U054", name: "IT Help Desk",    role: "Viewer",           email: "helpdesk@tcs.com",         status: "Active", lastLogin: "Today 10:00" },
      ],
      alerts: [
        { id: "SA-050", severity: "Warning",  type: "Device Offline", message: "AQM – 3rd Floor offline for 2h. Air quality on that floor unmonitored.",          time: "09:00 AM", status: "Active",       assignee: "Arjun Rao"   },
        { id: "SA-051", severity: "Warning",  type: "AQM Threshold",  message: "Lobby AQM – CO2 spiked to 1,180 ppm (8:45 AM). HVAC adjusted automatically.",     time: "08:45 AM", status: "Acknowledged", assignee: "Smita Pandey" },
        { id: "SA-052", severity: "Warning",  type: "Facility Alert", message: "HVAC Ctrl Main – filter replacement due. Efficiency at 78%.",                      time: "Yesterday", status: "Active",      assignee: "Kavya Nair"  },
      ],
      settings: {
        escalation: "30 min → Facility Mgr → 2h → Site Admin → 4h → Org Admin",
        maintenanceWindow: "Saturday 23:00–02:00 IST",
        slaTarget: "99.5%",
        dataRetention: "18 months",
        notificationChannels: ["SMS", "Email", "WhatsApp", "Push"],
      },
    },

    {
      id: "SITE-007",
      name: "Kolhapur Sugar Mill",
      type: "Factory",
      org: "Bhogavati Sugar Co-Op",
      orgId: "ORG-007",
      address: "Gavat Road, Kolhapur 416006, MH",
      lat: 16.706, lng: 74.235,
      timezone: "IST (UTC+5:30)",
      contact: "Ganesh Patil",
      phone: "+91-94220-67890",
      email: "ganesh.patil@bhogavati.com",
      status: "Trial",
      plan: "Basic",
      healthScore: 82,
      uptime: 96.5,
      createdAt: "2024-12-01",
      solutions: [
        { id: "STP",        name: "STP",        enabled: true, plan: "Basic", deviceCount: 5, activeAlerts: 0, features: ["Primary Treatment", "Flow Monitor"] },
        { id: "Water",      name: "Water",      enabled: true, plan: "Basic", deviceCount: 4, activeAlerts: 0, features: ["Tank Monitor", "Flow Meter"] },
        { id: "Irrigation", name: "Irrigation", enabled: true, plan: "Basic", deviceCount: 2, activeAlerts: 0, features: ["Drip Control"] },
      ],
      devices: [
        { id: "GW-KOL-001", name: "Kolhapur Gateway",      type: "Gateway",    connectivity: "Cellular", status: "Online", health: 88, lastSeen: "5 min ago" },
        { id: "STP-KOL-001", name: "Mill STP Inlet Meter", type: "Sensor",     connectivity: "Modbus",   status: "Online", health: 84, lastSeen: "5 min ago" },
        { id: "WTR-KOL-001", name: "Process Water Tank",   type: "Sensor",     connectivity: "LoRa",     status: "Online", health: 91, lastSeen: "3 min ago" },
      ],
      users: [
        { id: "U060", name: "Ganesh Patil",   role: "Site Admin", email: "ganesh.patil@bhogavati.com",  status: "Active", lastLogin: "Today 07:00" },
        { id: "U061", name: "Sanjay More",    role: "Technician", email: "sanjay.more@bhogavati.com",   status: "Active", lastLogin: "Yesterday"   },
      ],
      alerts: [],
      settings: {
        escalation: "2h → Site Admin → Org Admin",
        maintenanceWindow: "Tuesday 22:00–00:00 IST",
        slaTarget: "97.0%",
        dataRetention: "3 months",
        notificationChannels: ["SMS"],
      },
    },

    {
      id: "SITE-008",
      name: "Solapur Textile Factory",
      type: "Factory",
      org: "Shri Renuka Textiles",
      orgId: "ORG-008",
      address: "SIDCO Industrial Area, Solapur 413006, MH",
      lat: 17.695, lng: 75.910,
      timezone: "IST (UTC+5:30)",
      contact: "Ramesh Jadhav",
      phone: "+91-98901-89012",
      email: "ramesh.jadhav@renuka.com",
      status: "Inactive",
      plan: "Professional",
      healthScore: 0,
      uptime: 0,
      createdAt: "2023-06-12",
      solutions: [
        { id: "STP", name: "STP", enabled: false, plan: "Professional", deviceCount: 6, activeAlerts: 0, features: ["Full Treatment"] },
        { id: "AQM", name: "AQM", enabled: false, plan: "Basic",        deviceCount: 2, activeAlerts: 0, features: ["PM2.5"] },
      ],
      devices: [
        { id: "GW-SOL-001", name: "Solapur Gateway",     type: "Gateway",    connectivity: "Ethernet", status: "Offline", health: 0, lastSeen: "14 days ago" },
        { id: "STP-SOL-001", name: "STP Controller",     type: "Controller", connectivity: "Modbus",   status: "Offline", health: 0, lastSeen: "14 days ago" },
      ],
      users: [
        { id: "U070", name: "Ramesh Jadhav", role: "Site Admin", email: "ramesh.jadhav@renuka.com", status: "Inactive", lastLogin: "14 days ago" },
      ],
      alerts: [],
      settings: {
        escalation: "—",
        maintenanceWindow: "—",
        slaTarget: "—",
        dataRetention: "6 months",
        notificationChannels: [],
      },
    },
  ],

  // ── Device Pool (for device assignment in Create/Edit modal) ──────────────
  devicePool: [
    { id: "GW-FREE-001", name: "Unassigned Gateway 01",    type: "Gateway",    connectivity: "Ethernet", status: "Online" },
    { id: "GW-FREE-002", name: "Unassigned Gateway 02",    type: "Gateway",    connectivity: "Cellular", status: "Online" },
    { id: "SEN-FREE-001", name: "Free LoRa Sensor 01",     type: "Sensor",     connectivity: "LoRa",     status: "Online" },
    { id: "SEN-FREE-002", name: "Free LoRa Sensor 02",     type: "Sensor",     connectivity: "LoRa",     status: "Online" },
    { id: "CTL-FREE-001", name: "Free Modbus Controller",  type: "Controller", connectivity: "Modbus",   status: "Online" },
    { id: "TRK-FREE-001", name: "Fleet Tracker – Spare",   type: "Sensor",     connectivity: "Cellular", status: "Online" },
  ],

  // ── User Pool (for user assignment in Create/Edit modal) ──────────────────
  userPool: [
    { id: "UP001", name: "Amey Bhosle",    email: "amey.bhosle@iotmate.io",    role: "Technician"       },
    { id: "UP002", name: "Sneha Kulkarni", email: "sneha.kulkarni@iotmate.io", role: "Facility Manager" },
    { id: "UP003", name: "Rahul Deshpande",email: "rahul.d@iotmate.io",        role: "Viewer"           },
    { id: "UP004", name: "Manasi Gore",    email: "manasi.gore@iotmate.io",    role: "Site Admin"       },
    { id: "UP005", name: "Nikhil Pawar",   email: "nikhil.pawar@iotmate.io",   role: "Technician"       },
  ],
};
